import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Badge } from "@/components/ui/badge";
import { ACCESS_REQUEST_STATUS_BADGE } from "@/constants/messages";
import { StatusAccessREquest } from "@/enum/status";
import { AccessRequestDTO } from "@/services/dtos/accessRequest.dto";

import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";

export const COLUMN_TO_DB_FIELD: Record<string, string> = {
  Nome: "name",
  Loja: "store",
  CPF: "cpf",
  "Sla/Status": "status",
  "Data Criação": "created_at",
};

export const columns: ColumnDef<AccessRequestDTO>[] = [
  {
    id: "Nome",
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nome" />
    ),
  },
  {
    id: "Loja",
    accessorKey: "store",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Loja" />
    ),
    cell: ({ row }) => `Loja ${row.original.store}`,
  },
  {
    id: "CPF",
    accessorKey: "cpf",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CPF" />
    ),
    cell: ({ row }) =>
      row.original.cpf.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4",
      ),
  },
  {
    id: "Sla/Status",
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const statusValue = row.original.status as unknown as StatusAccessREquest;

      const isValidStatus =
        statusValue && Object.values(StatusAccessREquest).includes(statusValue);

      if (!isValidStatus) {
        return <Badge variant="default">Status Desconhecido</Badge>;
      }

      const currentStatus = ACCESS_REQUEST_STATUS_BADGE[statusValue];

      return <Badge variant={currentStatus.variant}>{currentStatus.label}</Badge>;
    },
  },
  {
    id: "Data Criação",
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data de Criação" />
    ),
    cell: ({ row }) => {
      const date = row.original.created_at;
      if (date) {
        const parsedDate = new Date(date);
        const formattedDate = format(parsedDate, "dd/MM/yyyy");
        return formattedDate;
      }
      return "Sem data";
    },
  },
  {
    id: "acoes",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
